//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/assets/css/notFound.css"; // 페이지를 찾을수없습니다 css

export default {
	components: {},
	created() {
	},
	computed: {},
	mounted() {
	},
};
